import { PlannerCoreApi } from './PlannerCoreApi';
export class NoCore extends PlannerCoreApi {
    async loadScene(_config, _setRoom) {
        throw new Error('Method not implemented.');
    }
    bootstrap() {
        throw new Error('No Core initialized.');
    }
    loadProductCatalogs() {
        throw new Error('No Core initialized.');
    }
    getMainProductCatalog() {
        throw new Error('Method not implemented.');
    }
    loadProppingCatalog() {
        throw new Error('No Core initialized.');
    }
    initSceneApi() {
        throw new Error('No Core initialized.');
    }
    initCameraApi() {
        throw new Error('No Core initialized.');
    }
}
//# sourceMappingURL=NoCore.js.map